import { EN_EEUU } from './en-eeuu'
import { ES_AR } from './es-ar'
import { ES_PE } from './es-pe'
import { ES_CL } from './es-cl'
import { ES_MX } from './es-mx'
import { ES_UY } from './es-uy'
import { ES_BO } from './es-bo'
import { ES_CO } from './es-co'
import { ES_EC } from './es-ec'
import { ES_CW } from './es-cw'
import { ES_BB } from './es-bb'
import { ES_TT } from './es-tt'
import { PT_BR } from './pt-br'

export const languages = {
  es: {
    value: 'ES',
    countries: ['ar', 'pe', 'cl', 'mx', 'uy', 'co', 've', 'py', 'pa', 'cr', 'gt', 'hn', 'sv', 'ec', 'bo','cw','bb','tt']
  },
  en: {
    value: 'EN',
    countries: ['us']
  },
  pt: {
    value: 'PT',
    countries: ['br']
  }
}

const messages = {
  ar: ES_AR,
  us: EN_EEUU,
  pe: ES_PE,
  cl: ES_CL,
  mx: ES_MX,
  uy: ES_UY,
  bo: ES_BO,
  co: ES_CO,
  ec: ES_EC,
  cw: ES_CW,
  bb: ES_BB,
  tt: ES_TT,
  br: PT_BR
}

export default messages
